$(function () {
  // =====================================================================
  // ヘッダーメガメニューのホバー制御
  // =====================================================================
  $(".header__inline-menu details.mega-menu")
    .on("mouseenter", function () {
      if (window.innerWidth >= 990) {
        $(this).attr("open", "true");
      }
    })
    .on("mouseleave", function () {
      if (window.innerWidth >= 990) {
        if ($(this).hasClass("is-clicked") || $(this).removeAttr("open")) {
          // jQueryのチェイン用の空ブロック
        }
      }
    });

  // =====================================================================
  // レビュー投稿のポイント案内（アプリが出力するレビュー領域にも対応）
  // =====================================================================
  function initializeReviewPoints() {
    document.querySelectorAll(".mxpr-block-product-review .mxpr-summary__write-review").forEach(function (button) {
      const summary = button.closest(".mxpr-summary");
      if (!summary || summary.querySelector(".mxpr-review-points")) return;
      const headline = summary.querySelector(".mxpr-summary__headline");
      if (!headline) return;

      const notice = document.createElement("div");
      notice.className = "mxpr-review-points";
      notice.innerHTML = '<p class="mxpr-review-points__message">レビュー投稿で<strong>300pt</strong>プレゼント！</p>' +
        '<p class="mxpr-review-points__condition">※ポイント付与は会員限定・1製品につき1回まで</p>';
      headline.insertAdjacentElement("afterend", notice);
    });
  }

  initializeReviewPoints();

  // =====================================================================
  // メインカルーセル・各種Swiperの初期化
  // =====================================================================
  const mySwiper = $(".mySwiper");
  if (mySwiper.length) {
    if (mySwiper[0].swiper) {
      mySwiper[0].swiper.destroy(true, true);
    }
    new Swiper(".mySwiper", {
      autoHeight: mySwiper.hasClass("top-hero-swiper"),
      loop: true,
      speed: 600,
      autoplay: { delay: 5000, disableOnInteraction: false },
      pagination: { el: ".swiper-pagination", clickable: true },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        990: { slidesPerView: "auto", centeredSlides: true, spaceBetween: 25 },
        0: { slidesPerView: 1, centeredSlides: false, spaceBetween: 0 },
      },
    });
  }

  $(".b-swiper-01").each(function () {
    const wrapper = $(this);
    const swiperEl = wrapper.find(".swiper");
    if (swiperEl.length) {
      new Swiper(swiperEl[0], {
        loop: false,
        speed: 600,
        slidesPerView: "auto",
        spaceBetween: 22,
        slidesOffsetAfter: 20,
        freeMode: false,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
        navigation: {
          nextEl: wrapper.find(".swiper-button-next")[0],
          prevEl: wrapper.find(".swiper-button-prev")[0],
        },
        breakpoints: {
          990: {
            spaceBetween: 24,
            freeMode: true,
          },
        },
      });
    }
  });

  $(".swiper-review").each(function () {
    const wrapper = $(this).closest(".user-voice-wrapper");
    new Swiper(this, {
      loop: false,
      speed: 600,
      slidesPerView: "auto",
      spaceBetween: 22,
      slidesOffsetAfter: 20,
      navigation: {
        nextEl: wrapper.find(".review-button-next")[0],
        prevEl: wrapper.find(".review-button-prev")[0],
      },
      breakpoints: {
        990: { slidesPerView: 2, spaceBetween: 24, slidesOffsetAfter: 0 },
        1200: { slidesPerView: 3, spaceBetween: 24, slidesOffsetAfter: 0 },
        1501: { slidesPerView: 4, spaceBetween: 24, slidesOffsetAfter: 0 },
      },
    });
  });

  // =====================================================================
  // カートモーダル制御
  // =====================================================================
  $(document).on("click", ".js-open-cart-modal", function (e) {
    e.preventDefault();
    const card = $(this).closest(".u-card-01, .card-wrapper");
    const modal = $(".js-cart-popup-modal");
    if (!card.length) return;

    const titleAnchor = card
      .find(".u-card-01__heading a, .card__heading a")
      .first();
    const titleText = titleAnchor.text().trim();
    const linkUrl = titleAnchor.attr("href");

    let imgSrc = "";
    const imgEl = card.find(".u-card-01__media img, .card__media img").first();
    if (imgEl.length) {
      imgSrc = imgEl.attr("src");
      if (imgSrc && imgSrc.includes("width=165")) {
        const srcset = imgEl.attr("srcset");
        if (srcset) {
          imgSrc = srcset.split(",")[0].split(" ")[0];
        }
      }
    }

    let priceText = "";
    const salePrice = card.find(".price-item--sale.price-item--last");
    if (salePrice.length && salePrice.text().trim() !== "") {
      priceText = salePrice.text().trim();
    } else {
      const regularPrice = card.find(".price-item--regular").not("s");
      if (regularPrice.length) {
        priceText = regularPrice.text().trim();
      } else {
        const fallbackPrice = card.find(".price").first();
        if (fallbackPrice.length) {
          priceText = fallbackPrice.text().trim();
        }
      }
    }
    priceText = priceText.replace("JPY", "").replace("から", "").trim();

    const variants = card.find(".variant-pill");
    const modalVariantsArea = modal.find(".js-modal-variants-area");
    const modalVariantsList = modal.find(".js-modal-variants-list");
    const modalVariantsLabel = modal.find(".js-modal-variants-label");

    modalVariantsList.empty();

    if (variants.length > 0) {
      modalVariantsArea.show();
      let hasColor = false;
      variants.each(function () {
        const text = $(this).text();
        if (
          text.includes("ブラック") ||
          text.includes("ベージュ") ||
          text.includes("色")
        ) {
          hasColor = true;
        }
      });

      modalVariantsLabel.text(
        hasColor
          ? "カラー（最初はカラーを選択してください）"
          : "サイズ（最初はサイズを選択してください）",
      );

      variants.each(function (index) {
        const text = $(this).text().trim();
        const activeClass = index === 0 ? "is-active" : "";
        let colorDot = "";

        if (text.includes("ブラック")) {
          colorDot =
            '<span class="color-dot" style="background-color: #000;"></span>';
        } else if (text.includes("ベージュ")) {
          colorDot =
            '<span class="color-dot" style="background-color: #d8c8b1;"></span>';
        }

        modalVariantsList.append(
          `<button class="cart-popup-modal__variants-btn ${activeClass}">${colorDot}${text}</button>`,
        );
      });
    } else {
      modalVariantsArea.hide();
    }

    modal.find(".js-modal-image").attr("src", imgSrc);
    modal.find(".js-modal-title").html(titleText);
    modal.find(".js-modal-price").text(priceText);
    modal.find(".js-modal-link").attr("href", linkUrl);
    modal.addClass("is-active");
  });

  $(document).on("click", ".js-cart-modal-close", function (e) {
    e.preventDefault();
    $(this).closest(".js-cart-popup-modal").removeClass("is-active");
  });

  $(document).on("click", ".cart-popup-modal__variants-btn", function () {
    $(this).siblings().removeClass("is-active");
    $(this).addClass("is-active");
  });

  // =====================================================================
  // レビューモーダル制御
  // =====================================================================
  $(document).on("click", ".js-open-review-modal", function (e) {
    e.preventDefault();
    const modal = $(".js-review-popup-modal");
    const card = $(this).closest(".u-card-02");

    const imgSrc = card.find(".u-card-02__image img").attr("src");
    const starClass = card.find(".star span").attr("class");
    const titleText = card.find(".u-card-02__title").text().trim();
    const contentText = card.find(".u-card-02__content").text().trim();
    const profileText = card.find(".u-card-02__profile").text().trim();
    const dateText = card.find(".u-card-02__date").text().trim();

    modal.find(".js-modal-product-img").attr("src", imgSrc);
    modal
      .find(".js-modal-product-title")
      .text(
        titleText.includes("カバー")
          ? "ヒツジのいらない枕カバー"
          : "ヒツジのいらない枕　ー至極ー",
      );
    modal.find(".js-modal-product-star").attr("class", starClass);
    modal.find(".js-modal-review-star").attr("class", starClass);
    modal.find(".js-modal-review-title").text(titleText);
    modal.find(".js-modal-review-text").text(contentText);
    modal.find(".js-modal-review-author").text(profileText);
    modal.find(".js-modal-review-date").text(dateText);

    modal
      .find(".js-modal-product-title-sub")
      .text(modal.find(".js-modal-product-title").text());
    modal.find(".review-popup-modal__scroll-area").scrollTop(0);
    modal.addClass("is-active");
  });

  $(document).on("click", ".js-review-modal-close", function (e) {
    e.preventDefault();
    $(this).closest(".js-review-popup-modal").removeClass("is-active");
  });

  // =====================================================================
  // アコーディオンテーブル（ドロップダウン）
  // =====================================================================
  function initializeComparisonTables(root) {
    $(root).find(".js-ddtbl").each(function () {
      const wrapper = $(this);
      if (wrapper.data("ddtblInitialized")) return;
      wrapper.data("ddtblInitialized", true);
      const header = wrapper.find(".js-ddtbl-header");
      const content = wrapper.find(".js-ddtbl-content");
      const swiperContainer = wrapper.find(".js-swiper-ddtbl");
      let swiperInstance = null;

      header.on("click", function (e) {
        if ($(e.target).closest(".b-ddtbl-01__nav").length) return;

        const isOpening = !wrapper.hasClass("is-open");
        if (isOpening) {
          content.show().css("visibility", "hidden");
          for (let i = 1; i <= 5; i++) {
            wrapper.find(".u-ddtbl-01__row--" + i).matchHeight();
          }

          if (!swiperInstance) {
            swiperInstance = new Swiper(swiperContainer[0], {
              loop: false,
              speed: 600,
              slidesPerView: "auto",
              spaceBetween: 0,
              freeMode: true,
              mousewheel: { forceToAxis: true },
              observer: true,
              observeParents: true,
              navigation: {
                nextEl: wrapper.find(".js-ddtbl-next")[0],
                prevEl: wrapper.find(".js-ddtbl-prev")[0],
              },
            });
          }
          content.hide().css("visibility", "visible");
        }

        wrapper.toggleClass("is-open");
        wrapper.find(".b-ddtbl-01__toggle").attr("aria-expanded", isOpening);
        content.stop().slideToggle(400, function () {
          if (isOpening) {
            if (swiperInstance) swiperInstance.update();
            $.fn.matchHeight._update();
          }
        });
      });
    });
  }

  initializeComparisonTables(document);
  document.addEventListener("shopify:section:load", function (event) {
    initializeComparisonTables(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    $(event.target).find(".js-swiper-ddtbl").each(function () {
      if (this.swiper) this.swiper.destroy(true, true);
    });
  });

  // =====================================================================
  // スタンドアロンテーブル
  // =====================================================================
  $(".js-standalone-tbl").each(function () {
    const wrapper = $(this);
    const swiperContainer = wrapper.find(".js-swiper-standalone");

    if (swiperContainer.length) {
      for (let i = 1; i <= 5; i++) {
        wrapper.find(".u-ddtbl-01__row--" + i).matchHeight();
      }
      new Swiper(swiperContainer[0], {
        loop: false,
        speed: 600,
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
        mousewheel: { forceToAxis: true },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      });
    }
  });

  // =====================================================================
  // 商品ギャラリー
  // =====================================================================
  if ($(".product-gallery").length) {
    const galleryThumbSwiper = new Swiper(".js-gallery-thumb", {
      spaceBetween: 4,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      direction: "horizontal",
      mousewheel: true,
    });

    const isSp = window.matchMedia("(max-width: 989px)").matches;

    new Swiper(".js-gallery-main", {
      spaceBetween: 0,
      effect: isSp ? "slide" : "fade",
      fadeEffect: isSp ? undefined : { crossFade: true },
      navigation: { nextEl: ".js-gallery-next", prevEl: ".js-gallery-prev" },
      thumbs: { swiper: galleryThumbSwiper },
      scrollbar: isSp
        ? { el: ".swiper-scrollbar", draggable: true, hide: true }
        : false,
    });
  }

  // =====================================================================
  // 商品フェードスワイパー
  // =====================================================================
  $(".js-product-fade-swiper").each(function () {
    if ($(this).find(".swiper-slide").length > 1) {
      new Swiper(this, {
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        speed: 1500,
        autoplay: { delay: 3000, disableOnInteraction: false },
        allowTouchMove: true,
      });
    }
  });

  // =====================================================================
  // ナビ付き商品スライダー
  // =====================================================================
  $(".js-product-slider-with-nav").each(function () {
    const wrapper = $(this);
    if (wrapper.find(".swiper-slide").length > 1) {
      new Swiper(this, {
        loop: true,
        effect: "slide",
        speed: 600,
        autoplay: { delay: 4000, disableOnInteraction: false },
        navigation: {
          nextEl: wrapper.find(".js-slide-next")[0],
          prevEl: wrapper.find(".js-slide-prev")[0],
        },
        allowTouchMove: true,
      });
    } else {
      wrapper.find(".slider-nav").hide();
    }
  });

  // =====================================================================
  // 専門家アコーディオン
  // =====================================================================
  $(".js-expert-accordion-header").on("click", function () {
    if (window.innerWidth <= 990) {
      $(this).toggleClass("is-open");
      $(this)
        .parent()
        .find(".js-expert-accordion-content")
        .stop()
        .slideToggle(300);
    }
  });

  // =====================================================================
  // レビューリスト もっと見る機能
  // =====================================================================
  const reviewList = $(".js-review-list");
  const reviewItems = reviewList.find(".review-item");
  const reviewMoreWrap = $(".review-more-wrap");
  const btnReviewMore = $(".js-review-more");
  const btnReviewMoreText = btnReviewMore.find("span");
  let currentReviewCount = 3;

  if (reviewList.length) {
    if (reviewItems.length <= 3) {
      reviewMoreWrap.hide();
      reviewItems.show();
    } else {
      reviewMoreWrap.show();
      reviewItems.hide();
      reviewItems.slice(0, currentReviewCount).show();
    }

    btnReviewMore.on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("is-open")) {
        currentReviewCount = 3;
        reviewItems.slice(3).stop().slideUp(300);
        $(this).removeClass("is-open");
        btnReviewMoreText.text("もっと読む");

        const offsetTop = reviewList.offset().top - 150;
        $("html, body").animate({ scrollTop: offsetTop }, 500);
      } else {
        const nextCount = currentReviewCount + 3;
        reviewItems.slice(currentReviewCount, nextCount).stop().slideDown(300);
        currentReviewCount = nextCount;

        if (currentReviewCount >= reviewItems.length) {
          $(this).addClass("is-open");
          btnReviewMoreText.text("閉じる");
        }
      }
    });
  }

  // =====================================================================
  // フローティングカート
  // =====================================================================
  const floatingCart = $(".js-floating-cart");
  const productGallery = $(".b-productdetail-01 .product-gallery");
  const footer = $(".footer");

  if (floatingCart.length && productGallery.length && footer.length) {
    $(window).on("scroll.floatingCart", function () {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const galleryBottom =
        productGallery.offset().top + productGallery.outerHeight();
      const footerTop = footer.offset().top;

      if (scrollTop > galleryBottom && scrollTop + windowHeight < footerTop) {
        floatingCart.addClass("is-visible");
      } else {
        floatingCart.removeClass("is-visible");
      }
    });

    $(".js-floating-btn-trigger").on("click", function () {
      $(".product-info__actions .btn-add-cart").trigger("click");
    });
  }

  // =====================================================================
  // SP用スワイパー (.js-sp-swiper)
  // =====================================================================
  function initSpSwiper() {
    const winWidth = window.innerWidth;
    $(".js-sp-swiper").each(function () {
      const wrapper = $(this);
      if (wrapper.find(".swiper-slide").length === 0) return;

      let swiperInstance = wrapper.data("swiper-instance");
      const desktopBreakpoint = wrapper.closest(".recently-viewed-wrapper").length ? 990 : 961;

      if (winWidth < desktopBreakpoint && !swiperInstance) {
        swiperInstance = new Swiper(wrapper[0], {
          loop: false,
          speed: 600,
          slidesPerView: "auto",
          spaceBetween: 22,
          navigation: {
            nextEl: wrapper.parent().find(".swiper-button-next")[0],
            prevEl: wrapper.parent().find(".swiper-button-prev")[0],
          },
        });
        wrapper.data("swiper-instance", swiperInstance);
      } else if (winWidth >= desktopBreakpoint && swiperInstance) {
        swiperInstance.destroy(true, true);
        wrapper.removeData("swiper-instance");
        wrapper.find(".swiper-wrapper").removeAttr("style");
      }
    });
  }

  initSpSwiper();
  $(window).on("resize", initSpSwiper);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        initializeReviewPoints();
        initSpSwiper();
      }
    });
  }).observe(document.body, { childList: true, subtree: true });
});

// =====================================================================
// バニラJS (DOMContentLoaded)
// =====================================================================
document.addEventListener("DOMContentLoaded", function () {
  // SP専用 スワイパー (.js-owned-sp-swiper)
  const ownedSpSwipers = document.querySelectorAll(".js-owned-sp-swiper");
  ownedSpSwipers.forEach((el) => {
    let swiperInstance = null;

    const initOrDestroySwiper = () => {
      const isSp = window.matchMedia("(max-width: 767px)").matches;
      if (isSp && !swiperInstance) {
        swiperInstance = new Swiper(el, {
          slidesPerView: 1.2,
          spaceBetween: 15,
        });
      } else if (!isSp && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };

    initOrDestroySwiper();
    window.addEventListener("resize", initOrDestroySwiper);
  });

  // 画像拡大モーダル制御
  const zoomBtn = document.getElementById("js-zoom-btn");
  const modal = document.getElementById("js-image-modal");
  const modalImg = document.getElementById("js-modal-img");
  const closeBtn = document.querySelector(".product-gallery__modal-close");

  if (!zoomBtn || !modal) return;

  zoomBtn.addEventListener("click", function () {
    const activeSlide = document.querySelector(
      ".js-gallery-main .swiper-slide-active",
    );
    if (!activeSlide) return;

    const mediaType = activeSlide.getAttribute("data-media-type");
    if (mediaType !== "image") {
      return;
    }

    const imgElement = activeSlide.querySelector("img");
    if (imgElement) {
      const imgSrc = imgElement.currentSrc || imgElement.src;
      modalImg.src = imgSrc;
      modal.classList.add("is-active");
    }
  });

  closeBtn.addEventListener("click", function () {
    modal.classList.remove("is-active");
  });

  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.classList.remove("is-active");
    }
  });
});
